import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getMonthlyRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../../utils/date-range-options";
import {
  SET_LOADING,
  SET_PRIMARY_CATEGORIES_LOADING,
  SET_SECONDARY_CATEGORIES_LOADING,
  SET_PRICING_OPTIONS_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_FILTERS_LOADING,
  SET_DATES,
  UPDATE_DATES,
  FETCH_CHART_DATA_SUCCESS,
  SET_UPDATES_LOADING,
  RESET_FILTER_SELECTED,
  UPDATE_PRIMARY_CATEGORY_SELECTED,
  UPDATE_MEMBERSHIP_TYPES_OPTION_SELECTED,
  UPDATE_SECONDARY_CATEGORY_SELECTED,
  UPDATE_PRICING_OPTION_SELECTED,
  UPDATE_TABLE_VIEW_SELECTED,
  UPDATE_CUSTOM_RANGE,
  UPDATE_ONLY_MEMBERSHIPS_SELECTED,
  UPDATE_GROUP_BY,
  UPDATE_MEMBERSHIP_TYPES,
  UPDATE_TYPE_SELECTED,
  UPDATE_AVERAGE_BREAKDOWN_SELECTED,
  SET_CHART_LOADING
} from "./averageNumberOfVisitsPerClientSagas";

function secondaryCategory(useSecondaryCategories) {
  return { id: "secondary", name: `${useSecondaryCategories ? "Secondary" : ""} Category` };
}
export const initialState = {
  currentUser: {},
  initialRequest: false,
  chartData: { data_table: {} },
  totalData: {},
  isLoading: true,
  chartLoading: false,
  isFiltersLoading: false,
  updatesLoading: false,
  primaryCategoriesLoading: false,
  secondaryCategoriesLoading: false,
  pricingOptionsLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  datesDirty: false,
  filters: {
    type: [
      { id: "category", name: "Category" },
      { id: "membership_type", name: "Membership Type" }
    ],
    primary_categories: [],
    secondary_categories: [],
    pricing_options: [],
    toggles: {
      onlyMemberships: {}
    },
    membership_types: []
  },
  selectedFilters: {
    type: { id: "membership_type", name: "Membership Type" },
    group_by: {},
    average_breakdown: { id: "total", name: "Total" },
    table_view: false,
    only_memberships: false,
    primary_categories: [],
    secondary_categories: [],
    pricing_options: [],
    membership_types: []
  },
  groupBy: [],
  selectedRangeOption: {},
  rangeOptions: []
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_PRIMARY_CATEGORIES_LOADING]: (state, action) => ({
      ...state,
      primaryCategoriesLoading: action.payload
    }),
    [SET_SECONDARY_CATEGORIES_LOADING]: (state, action) => ({
      ...state,
      secondaryCategoriesLoading: action.payload
    }),
    [SET_PRICING_OPTIONS_LOADING]: (state, action) => ({
      ...state,
      pricingOptionsLoading: action.payload
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      isFiltersLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      let rangeOptions = getMonthlyRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.theBeginningOfTime
      );

      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: [...rangeOptions, getSelectedRangeOptionWithCustom(action)],
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.theBeginningOfTime
      ),
      filtersDirty: true,
      datesDirty: true
    }),
    [UPDATE_GROUP_BY]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        group_by: action.payload
      }
    }),
    [UPDATE_TYPE_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        type: action.payload
      }
    }),
    [UPDATE_MEMBERSHIP_TYPES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, membership_types: action.payload }
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true,
      datesDirty: true,
      selectedFilters: {
        ...state.selectedFilters
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_CHART_DATA_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload.data || state.chartData,
      totalData: action.payload.visitsCount || state.totalData
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => {
      const useSecondaryCategories = state.currentUser.useSecondaryCategories;
      const secondary = secondaryCategory(useSecondaryCategories);
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        selectedFilters: {
          ...state.selectedFilters,
          only_memberships: action.payload.toggles.showMembershipsOnly.default ?? false,
          group_by: useSecondaryCategories
            ? { id: "primary", name: "Primary Category" }
            : secondary,
          membership_types: action.payload.membership_types
        },
        groupBy: [
          ...(useSecondaryCategories ? [{ id: "primary", name: "Primary Category" }] : []),
          secondary,
          { id: "pricing_option", name: "Sales Package" }
        ]
      };
    },
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      datesDirty: false,
      selectedFilters: {
        ...initialState.selectedFilters,
        primary_categories: state.filters.primary_categories,
        secondary_categories: state.filters.secondary_categories,
        pricing_options: state.filters.pricing_options,
        only_memberships: state.filters.toggles.showMembershipsOnly.default,
        group_by: secondaryCategory(state.currentUser.useSecondaryCategories)
      }
    }),
    [UPDATE_PRIMARY_CATEGORY_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        primary_categories: [...action.payload]
      }
    }),
    [UPDATE_SECONDARY_CATEGORY_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        secondary_categories: [...action.payload]
      }
    }),
    [UPDATE_PRICING_OPTION_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        pricing_options: [...action.payload]
      }
    }),
    [UPDATE_MEMBERSHIP_TYPES_OPTION_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        membership_types: [...action.payload]
      }
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [UPDATE_ONLY_MEMBERSHIPS_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        only_memberships: action.payload
      }
    }),
    [UPDATE_AVERAGE_BREAKDOWN_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        average_breakdown: action.payload
      }
    }),
    [SET_CHART_LOADING]: (state, action) => ({
      ...state,
      chartLoading: action.payload
    })
  },
  initialState
);
